import React from "react";

const DateFormat = ({ date }) => {
  if (!date) return <>-</>;

  return (
    <>
      {new Date(date).toLocaleString("en-IN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })}
    </>
  );
};

export default DateFormat;